import { confirmable } from 'react-confirm';
import { useTranslation } from 'react-i18next';
import StackedModal from './stacked_modal';
import { Box, Typography } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { RHFAutocomplete } from 'src/components/hook_form/rhf_autocomplete';
import RHFTextField from 'src/components/hook_form/rhf_text_field';
import { useCommonCode } from 'src/hooks/use_common_code';
import { requiredField } from 'src/utils/format_data';

function OutboundIssueDialog({ show, proceed, title, content, failMessage }) {
  const { t } = useTranslation(['common', 'outbound', 'placeholder']);
  const { options: issueTypeOptions } = useCommonCode('hold_type');
  const methods = useForm({
    defaultValues: { issueType: null, issueReason: failMessage || '' },
  });
  const { issueType, issueReason } = methods.watch();

  return (
    <FormProvider {...methods}>
      <StackedModal
        isOpen={show}
        title={title || t('common:button.confirm')}
        content={
          <Box
            display={'flex'}
            flexDirection={'column'}
          >
            <span>{content}</span>
            <Box
              display={'flex'}
              flexDirection={'column'}
              gap={'4px'}
            >
              <Typography variant={'body_md_semibold'}>
                {requiredField(t('outbound:field.issue_type'))}
              </Typography>
              <RHFAutocomplete
                name="issueType"
                placeholder={t('placeholder:issue_type')}
                options={issueTypeOptions}
                getOptionLabel={(option) => option?.label ?? ''}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
              />
            </Box>
            <Box
              display={'flex'}
              flexDirection={'column'}
              gap={'4px'}
              mt={'12px'}
            >
              <Typography variant={'body_md_semibold'}>
                {t('outbound:field.issue_reason')}
              </Typography>
              <RHFTextField
                name="issueReason"
                multiline={true}
                rows={2}
                placeholder={t('placeholder:issue_reason')}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.stopPropagation();
                  }
                }}
              />
            </Box>
          </Box>
        }
        primaryAction={{
          content: t('common:button.confirm'),
          disabled: !issueType || !issueReason,
          onAction: () => {
            proceed({
              confirmed: true,
              value: issueReason,
              holdType: issueType?.value ?? issueType,
            });
          },
        }}
        onClose={() => {
          proceed({ confirmed: false, value: null });
        }}
      />
    </FormProvider>
  );
}

export default confirmable(OutboundIssueDialog);
